import { useEffect } from "react";
import { tinykeys } from "tinykeys";
import { useProjectLimitsContext } from "../components/limits/ProjectLimitsContext";

const useProjectLimitsShortcuts = () => {
  const { setIsAddLimitsDialogOpen } = useProjectLimitsContext();

  useEffect(() => {
    const unsubscribe = tinykeys(window, {
      "$mod+a": (event: KeyboardEvent) => {
        event.preventDefault();
        setIsAddLimitsDialogOpen(true);
      },
    });
    return () => {
      unsubscribe();
    };
  });
};

export default useProjectLimitsShortcuts;
